import {
  Action,
  ActionType,
  IPatientListResponse,
} from "models/patients/patientList";
import createReducer from "redux/createReducer";

export interface PatientListReducerType {
  loading: boolean;
  error?: string;
  patientListResponse?: IPatientListResponse;
}

const defaultState: PatientListReducerType = {
  loading: false,
  error: undefined,
  patientListResponse: undefined,
};

export const patientListReducer = createReducer<PatientListReducerType>(
  defaultState,
  {
    [ActionType.GET_PATIENT_LIST](state: PatientListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_PATIENT_LIST_ERROR](
      state: PatientListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        patientListResponse: undefined,
      };
    },

    [ActionType.GET_PATIENT_LIST_SUCCESS](
      state: PatientListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        patientListResponse: action.payload,
      };
    },

    [ActionType.GET_PATIENT_LIST_RESET](state: PatientListReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        patientListResponse: undefined,
      };
    },
  }
);
